'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = Info;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _browserVendorPrefix = require('browser-vendor-prefix');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function Info(props) {
  var wrapperStyle = _extends({}, style.wrapper, props.style);

  return _react2['default'].createElement(
    'div',
    { style: wrapperStyle },
    _react2['default'].createElement('img', { src: '/icons/' + props.type + '.svg', alt: props.type, style: style.image }),
    _react2['default'].createElement(
      'span',
      { style: style.text },
      props.text
    )
  );
}

;

var style = {
  wrapper: _extends({}, _browserVendorPrefix.alignItemsCenter, _browserVendorPrefix.flexDirectionRow, {
    fontSize: 12
  }),
  image: {
    width: 24
  },
  text: {
    marginLeft: 10,
    width: '100%'
  }
};
module.exports = exports['default'];